/**
 * The agreed nomenclature for touchpoint's names are:
 *   PAGE_PRODUCT_COMPONENT
 *   Examples: mytrips_cars_banner, confirmation_hotels_emerginglayer
 * */

const XSELL_TOUCHPOINTS = {
    confirmation_cars_banner: 'confirmation_cars_banner',
    confirmation_cars_emerginglayer: 'confirmation_cars_emerginglayer',
    confirmation_cars_smartblock: 'confirmation_cars_smartblock',
    confirmation_hotels_banner: 'confirmation_hotels_banner',
    confirmation_hotels_emerginglayer: 'confirmation_hotels_emerginglayer',
    confirmation_hotels_iframe: 'confirmation_hotels_iframe',
    pending_cars_smartblock: 'pending_cars_smartblock',
    mytrips_cars_banner: 'mytrips_cars_banner',
    mytrips_hotels_banner: 'mytrips_hotels_banner',
    mytripdetails_cars_banner: 'mytripdetails_cars_banner',
    mytripdetails_cars_itinerary_textlink: 'mytripdetails_cars_itinerary_textlink',
    mytripdetails_cars_itinerary_banner: 'mytripdetails_cars_itinerary_banner',
    mytripdetails_cars_smartblock: 'mytripdetails_cars_smartblock',
    mytripdetails_cars_smartblock_widget: 'mytripdetails_cars_smartblock_widget',
    mytripsdetails_hotels_emerginglayer: 'mytripsdetails_hotels_emerginglayer',
    mytripsdetails_hotels_iframe: 'mytripsdetails_hotels_iframe',
    mytripsdetails_hotels_widget: 'mytripsdetails_hotels_widget',
    mytripsdetails_hotels_banner: 'mytripsdetails_hotels_banner',
    mytripsdetails_hotels_itinerary_textlink: 'mytripsdetails_hotels_itinerary_textlink',
    mytripsdetails_hotels_floating_button: 'mytrips_details_hotels_floating_button',
    mytripsdetails_gt_itinerary_textlink: 'mytrips_details_hotels_floating_button',
    gyg_banner: 'gyg_banner',
    mytripdetails_gyg_itinerary_textlink: 'mytripdetails_gyg_itinerary_textlink',
    mytripdetails_gyg_itinerary_banner: 'mytripdetails_gyg_itinerary_banner',
    gyg_widget: 'gyg_widget',
    gyg_widget_button: 'gyg_widget_button',
    gyg_emerginglayer: 'gyg_emerginglayer',
    sbextension_search_pc_of: 'sbextension-search-pc-of',
    supportarea_hotels_textlink: 'supportarea_hotels_textlink',
};

module.exports = XSELL_TOUCHPOINTS;
